import React from 'react';

import { Paper, Typography } from '@mui/material';

const CARD_SX = { flex: 1, minWidth: 110, p: 1.5, border: 1, borderColor: 'grey.200', borderRadius: 2 } as const;

interface Props {
  label: string;
  count: number;
  color: string;
}

export default function StatCard({ label, count, color }: Props) {
  return (
    <Paper elevation={0} sx={CARD_SX}>
      <Typography variant="body2" color="text.secondary" mb={0.5}>
        {label}
      </Typography>
      <Typography variant="h5" fontWeight={600} color={count > 0 ? color : 'text.disabled'}>
        {count}
      </Typography>
    </Paper>
  );
}
